<template>
	<section class="bg-main">
		<div class="py-12"></div>
		<div class="vx-row justify-center m-0">
			<div class="vx-col w-full md:w-3/4 lg:w-1/2 xl:w-1/3">
				<vx-card>
					<p class="mb-2"><strong>Password Baru</strong></p>
					<vs-input
						ref="password"
					    v-model="password"
					    type="password"
					    name="password"
					    v-validate="'required'"
					    class="rounded w-full mb-4"
					    @keyup.enter="resetPassword"
					/>
					<span v-if="errors.has('password')" class="text-danger mb-4 block">
						{{ errors.first('password') }}
					</span>
					<p class="mb-2"><strong>Konfirmasi Password Baru</strong></p>
					<vs-input
					    v-model="conf_password"
					    type="password"
					    name="conf_password"
					    v-validate="'required|confirmed:password'"
					    class="rounded w-full mb-4"
					    @keyup.enter="resetPassword"
					/>
					<span v-if="errors.has('conf_password')" class="text-danger mb-4 block">
						{{ errors.first('conf_password') }}
					</span>
					<vs-button @click.prevent="resetPassword">
						Reset Password
					</vs-button>
				</vx-card>
			</div>
		</div>
		<div class="py-12"></div>
	</section>
</template>
<script>
	import { Validator } from 'vee-validate'

	const dict = {
		custom: {
			password: {
				required: 'Harap masukan password baru anda'
			},
			conf_password: {
				required: 'Harap masukan konfirmasi password',
				confirmed: 'Password dan konfirmasi password tidak sama'
			}
		}
	}

	Validator.localize('en', dict)

	export default {
		data: () => ({
			password: null,
			conf_password: null
		}),
		methods: {
			resetPassword() {
				
				this.$validator.validateAll().then(res => {
					if(res) {
						this.$vs.loading()
						const verifyId = this.$route.params.id
						this.$store.dispatch('auth/resetPassword', {verifyId, password: this.password})
						.then(() => {
							this.$vs.loading.close()
							this.$vs.notify({
								title: 'Password anda berhasil diperbaharui',
								text: 'Untuk memastikan password baru anda, silahkan login',
								color: 'success',
								position: 'top-right'
							})

							setTimeout(() => {
								this.$router.push('/login')
							}, 1000)
						})
						.catch(e => {
							this.$vs.loading.close()
							this.showError(e)

							return false
						})
					}
				})
			}
		}
	}
</script>
<style>
	.bg-main {
		background-image: url('/assets/images/footer/bg.svg');
		background-repeat: no-repeat;
		background-size: cover;
	}
</style>